import './css/styles.scss';

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';


function ShowNhide() {
    const iconPlus = `
        <svg style="width: 20px; height: 20px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
        <path fill="#3C4C5A" d="M544 320C544 196.3 443.7 96 320 96C196.3 96 96 196.3 96 320C96 443.7 196.3 544 320 544C443.7 544 544 443.7 544 320zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320zM320 224C293.5 224 272 245.5 272 272C272 280.8 264.8 288 256 288C247.2 288 240 280.8 240 272C240 227.8 275.8 192 320 192C364.2 192 400 227.8 400 272C400 311.6 374.3 332.3 353.8 342.1C342.3 347.6 336 356.6 336 364.3L336 370C336 378.8 328.8 386 320 386C311.2 386 304 378.8 304 370L304 364.3C304 339.7 322.3 321.7 340 313.3C354.5 306.4 368 294.5 368 272.1C368 245.6 346.5 224.1 320 224.1zM296 440C296 426.7 306.7 416 320 416C333.3 416 344 426.7 344 440C344 453.3 333.3 464 320 464C306.7 464 296 453.3 296 440z"/>
        </svg>
        `;

        const iconClose = `
        <svg style="width:20px;height:20px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
        <path fill="#3C4C5A" d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/>
        </svg>
        `;


    const Produktforfragan = document.querySelector('.produkt-forfragan');
    const ProduktforfraganBtn = document.querySelector('.produkt-forfragan-btn');

    if (ProduktforfraganBtn && Produktforfragan) {
            // Hämta ursprunglig knapptext utan SVG
        const originalText = ProduktforfraganBtn.textContent.trim();
        ProduktforfraganBtn.addEventListener('click', () => {
            Produktforfragan.classList.toggle('show-forfragan');
            const isActive =ProduktforfraganBtn.classList.toggle('active-btn');

            ProduktforfraganBtn.innerHTML = isActive 
            ? `${originalText} ${iconClose}` 
            : `${originalText} ${iconPlus}`;
        });
    }

}

function ShowNhidebestallning() {
    const iconPlus = `
        <svg style="width:20px;height:20px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
        <path fill="#ffffff" d="M352 64C352 46.3 337.7 32 320 32C302.3 32 288 46.3 288 64L288 306.7L278.6 297.3C266.1 284.8 245.8 284.8 233.3 297.3C220.8 309.8 220.8 330.1 233.3 342.6L297.3 406.6C309.8 419.1 330.1 419.1 342.6 406.6L406.6 342.6C419.1 330.1 419.1 309.8 406.6 297.3C394.1 284.8 373.8 284.8 361.3 297.3L352 306.7L352 64zM160 160C124.7 160 96 188.7 96 224L96 512C96 547.3 124.7 576 160 576L480 576C515.3 576 544 547.3 544 512L544 224C544 188.7 515.3 160 480 160L448 160C430.3 160 416 174.3 416 192C416 209.7 430.3 224 448 224L480 224L480 512L160 512L160 224L192 224C209.7 224 224 209.7 224 192C224 174.3 209.7 160 192 160L160 160z"/>
        </svg>
        `;

        const iconClose = `
        <svg style="width:20px;height:20px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
        <path fill="#ffffff" d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/>
        </svg>
        `;


    const BestallProdukt = document.querySelector('.bestall-produkt');
    const BestallProduktBtn = document.querySelector('.bestall-produkt-btn');

    if (BestallProduktBtn && BestallProdukt) {
            // Hämta ursprunglig knapptext utan SVG
        const originalText = BestallProduktBtn.textContent.trim();
        BestallProduktBtn.addEventListener('click', () => {
            BestallProdukt.classList.toggle('show-forfragan');
            const isActive =BestallProduktBtn.classList.toggle('active-btn');

            BestallProduktBtn.innerHTML = isActive 
            ? `${originalText} ${iconClose}` 
            : `${originalText} ${iconPlus}`;
        });
    }

}




ShowNhide();

// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	ShowNhide();
    ShowNhidebestallning()
    Fancybox.bind('[data-fancybox]', {
        hideScrollbar: false,
        dragToClose: false,
        closeButton: true,
        Toolbar: false,
        Image: {
            zoom: false,
            click: 'close',
            wheel: 'close',
        },
        showClass: 'fancybox-zoomIn',
        hideClass: 'fancybox-zoomOut',
    });
});